import React from 'react';
import Header from '../components/header/Header';
import About from '../components/about/About';
import Portfolio from '../components/portfolio/Portfolio';
import Terminal from '../components/terminal/Terminal';
import Skills from '../components/skills/Skills';
import Experience from '../components/experience/Experience';
import Services from '../components/services/Services';
import Contact from '../components/contact/Contact';

const Home = () => {
  return (
    <div className="home-page">
      <Header />
      <About />
      <Portfolio />
      <Terminal />
      <Skills />
      <Experience />
      <Services />
      <Contact />
    </div>
  );
};

export default Home;
